// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610080946/js/" + chunkId + "." + {"44":"b379e528","225":"a6768376","481":"6f19c610","486":"a22ae7b9","770":"298bb089"}[chunkId] + ".0.7702869720728214.chunk.js";
};